import Service from '../service.js';
import Pagination from '@/components/pagination/index.vue';
import { changeSkin } from '@/utils/common.js';

export default {
  components: {
    Pagination
  },
  data() {
    return {
      activeIndex: 1,
      tabActiveType: '1',
      newsList: [],
      pageNum: 1,
      pageSize: 5,
      total: 0,
      catalogIds: ['67bec61346cb25d6d284f5a8', '67bec61946cb25d6d284f5a9', '67bec61f46cb25d6d284f5aa', '67da271b3e7d4606761cc285'],
      policyList: [],
      newsList1: [],
      activities: [],
      num: 0
    };
  },
  created() {
    this.activeIndex = Number((this.$route.query.id) || 1);
    this.getnews();
  },
  mounted() {
    window.scrollTo(0, 0); // 让页面滚动到顶部
  },
  computed: {
  },
  methods: {
    changeSkin,
    // formate日期
    getCreatedTimeDay(date) {
      const baseDateFilter = this.$options.filters['baseDate'];
      const baseDate = baseDateFilter(date);
      return baseDate.substring(8, 10);
    },
    getCreatedTimeYear(date) {
      const baseDateFilter = this.$options.filters['baseDate'];
      const baseDate = baseDateFilter(date);
      return baseDate.substring(0, 7);
    },
    // 详情
    toDetailPage(id) {
      this.$router.push({
        path: '/finance-insurance/InformationDetails',
        query: {
          id: id
        }
      });
      // console.log(id, '3231');
    },
    changeTabIndex(type) {
      this.activeIndex = type;
      this.getnews();
    },
    getnews(page) {
      let limit = 5;
      let skip = 0;
      if (page) {
        skip = (page.pageNo - 1) * 5;
        limit = page.pageSize;
        this.pageNum = page.pageNo;
        this.pageSize = page.pageSize;
      }
      this.newsList = [];
      Service.getnews({ catalogId: this.catalogIds[this.activeIndex-1], limit: limit, skip: skip }).then(res => {
        this.newsList = res.result;
        this.total = res.total;
      });
    },
    handClick(val) {
      this.activeIndex = val;
      this.getnews();
    }
  }
};
